import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivClearanceApprovalViewModelGen,
  MrfiktivCreateRequestStatusHistoryElementDtoGen,
  MrfiktivUpdateClearanceApprovalFileDtoGen
} from "../v1/data-contracts";
import { ClearanceApprovalRequest } from "../v1/ClearanceApprovalRequest"; // Adjusted import

/**
 * Communicate with ClearanceApprovalRequest API
 */
class ClearanceApprovalRequestService {
  mrfiktivProxy: ClearanceApprovalRequest;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new ClearanceApprovalRequest(mrfiktivHttpClientProvider.client());
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param clearanceApprovalId
   * @param sct
   * @returns
   */
  async getDocumentBySharedAccessToken(
    partnerId: string,
    clearanceApprovalId: string,
    sct: string
  ): Promise<MrfiktivClearanceApprovalViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceApprovalRequestControllerGet({
      partnerId,
      clearanceApprovalId,
      sct
    });

    return shared.data;
  }
  /**
   *
   * Accepts a clearance approval request with optional file upload
   *
   * @param partnerId
   * @param clearanceApprovalId
   * @param sct
   * @param data
   * @returns
   */
  async respondAccept(
    partnerId: string,
    clearanceApprovalId: string,
    sct: string,
    data: MrfiktivUpdateClearanceApprovalFileDtoGen
  ): Promise<MrfiktivClearanceApprovalViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceApprovalRequestControllerAccept(
      {
        partnerId,
        clearanceApprovalId,
        sct
      },
      data
    );

    return shared.data;
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param clearanceApprovalId
   * @param sct
   * @param data
   * @returns
   */
  async respondReject(
    partnerId: string,
    clearanceApprovalId: string,
    sct: string,
    data: MrfiktivCreateRequestStatusHistoryElementDtoGen
  ): Promise<MrfiktivClearanceApprovalViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceApprovalRequestControllerReject(
      { partnerId, clearanceApprovalId, sct },
      data
    );

    return shared.data;
  }
}

/**
 * Communicate with ClearanceApprovalRequest API
 */
export default new ClearanceApprovalRequestService(new MrfiktivHttpClientProvider());
